


import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling

function GKI_Readiness_Index() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div className="pdf-page">
  <iframe
    src={t('Digital_Library_GKI_PDF')}
    title="PDF Document"
  />
</div>

  );
};

export default GKI_Readiness_Index;
